























































import { ApiClient } from "@/api/client";
import { AuthClient, authClient } from "@/auth0";
import { Component, Vue, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import ChargeAccount from "@/components/ChargeAccount.vue";
import Footer from "@/components/Footer.vue";
import NavBar from "@/components/NavBar.vue";
import PaymentResponse from "@/components/PaymentResponse.vue";
import vueProgressBar from "vue-progressbar/src/vue-progressbar.vue";

interface IPaymentResponse {
  isModalVisible: boolean;
  paymentProvider: string;
  status: string;
  paymentId: string;
  key: string;
}

@Component({
  components: {
    NavBar,
    vueProgressBar,
    ChargeAccount,
    PaymentResponse,
    Footer
  },
  computed: {
    ...mapState(["cannotLoadPage", "isLoading"])
  }
})
export default class App extends Vue {
  // Mapped from vuex
  cannotLoadPage!: boolean;

  // Other variables
  paymentResponse: IPaymentResponse = {
    isModalVisible: false,
    paymentProvider: "",
    status: "",
    paymentId: "",
    key: ""
  };

  auth: AuthClient = authClient;

  mounted() {
    this.$store.commit("stopLoading");
  }

  get isChargeModalVisible(): boolean {
    return this.$store.state.showChargeModal;
  }

  set isChargeModalVisible(newValue: boolean) {
    this.$store.commit("basic", {
      key: "showChargeModal",
      value: newValue
    });
  }

  @Watch("$route.query")
  onRouteQueryChange(query: any) {
    this.checkForPaymentCallback(query);
  }

  @Watch("auth.isAuthenticated")
  async onAuthChange(isAuthenticated: boolean, before: boolean) {
    console.debug(
      `[AUTHWATCH] - isAuthenticated changed from ${before} to ${isAuthenticated}.`
    );

    if (isAuthenticated) {
      const newAccount = await new ApiClient().getAccountInfo();
      this.$store.commit("setUser", newAccount);
    }
  }

  @Watch("cannotLoadPage")
  onCannotLoadPage(newValue: boolean) {
    if (newValue) {
      this.$Progress.set(100);
      this.$Progress.fail();
    }
  }

  checkForPaymentCallback(query: any) {
    if (query.paymentcallback) {
      this.paymentResponse.isModalVisible = true;
      this.paymentResponse.paymentProvider = query.paymentcallback;
      this.paymentResponse.status = query.status;
      this.paymentResponse.paymentId = query.payment_id;
      this.paymentResponse.key = JSON.stringify(query);

      // Remove parameters from URL
      this.$router.push(this.$route.path);
    }
  }
}
